import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  StyledLiTab,
  StyledIconPlus,
  StyledIconMinus,
  StyledTitleTabs,
  StyledTitleIcon,
  StyleContentCollapse,
  StyledEffect
} from './style';
import { Plus, Minus } from '../../../../assets/images/index';

class Tab extends PureComponent {
  render() {
    const { wellness } = this.props;
    return (
      <StyledLiTab
        vertical={this.props.vertical}
        className={this.props.className}
        onClick={this.props.onClick}
      >
        <StyledTitleIcon active={this.props.active} wellness={wellness}>
          {this.props.icon ? (
            this.props.icon
          ) : (
            <StyledTitleTabs> {this.props.label} </StyledTitleTabs>
          )}
          <StyledIconPlus
            svg={Plus}
            active={this.props.active}
            onClick={this.props.onClick}
          />
          <StyledIconMinus svg={Minus} active={this.props.active} />
        </StyledTitleIcon>
        <StyledEffect effect={this.props.content && true}>
          {this.props.content && (
            <StyleContentCollapse> {this.props.content} </StyleContentCollapse>
          )}
        </StyledEffect>
      </StyledLiTab>
    );
  }
}

Tab.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClick: PropTypes.func,
  vertical: PropTypes.bool,
  content: PropTypes.node,
  icon: PropTypes.node,
  wellness: PropTypes.bool
};

Tab.defaultProps = {
  active: false,
  className: '',
  label: '',
  vertical: false,
  wellness: false
};

export default Tab;
